module.exports = __webpack_public_path__ + "static/media/mainbanner_keyword_all.2b7838e2.jpg";